import { ConsumerOtpAdapter } from '../../adapters/consumer-otp';
import { CscValidationAdapter } from '../../adapters/csc-validation';
import { FidoAdapter } from '../../adapters/fido';
import { LvlrAdapter } from '../../adapters/lvlr';
import { MdesAdapter } from '../../adapters/mdes';
import { ThreeDsAdapter } from '../../adapters/threeds';
import { AuthenticationStrategy } from '../../types/enums/AuthenticationStrategy';
import { getStrategyReasons } from './getStrategyReasons';
/**
 * Instantiates the Strategy map.
 */
export function getStrategies(payload, params) {
    const consumerContext = getStrategyContext(payload, AuthenticationStrategy.CONSUMER_OTP);
    const fidoContext = getStrategyContext(payload, AuthenticationStrategy.FIDO2);
    const lvlrContext = getStrategyContext(payload, AuthenticationStrategy.LVLR);
    const mdesContext = getStrategyContext(payload, AuthenticationStrategy.MDES);
    const threeDsContext = getStrategyContext(payload, AuthenticationStrategy.THREE_DS);
    const cscValidationContext = getStrategyContext(payload, AuthenticationStrategy.CSC_VALIDATION);
    return {
        [AuthenticationStrategy.CONSUMER_OTP]: new ConsumerOtpAdapter(consumerContext),
        [AuthenticationStrategy.FIDO2]: new FidoAdapter(fidoContext),
        [AuthenticationStrategy.LVLR]: new LvlrAdapter(lvlrContext),
        [AuthenticationStrategy.MDES]: new MdesAdapter(mdesContext),
        [AuthenticationStrategy.THREE_DS]: new ThreeDsAdapter(threeDsContext),
        [AuthenticationStrategy.CSC_VALIDATION]: new CscValidationAdapter(cscValidationContext)
    };
    function getStrategyContext(payload, strategy) {
        return Object.assign(Object.assign({}, payload), { accountReference: params.accountReference, authenticationReasons: getStrategyReasons(params.authenticationStrategies, strategy) });
    }
}
